const NOT_APPLY = 0;
const PUBLISHED = 1;
const IN_REVIEW = 2;
const DRAFT = 3;
const MOVING = 100;

export default {
  NOT_APPLY,
  PUBLISHED,
  IN_REVIEW,
  DRAFT,
  MOVING
};
